// extracted by mini-css-extract-plugin
module.exports = {"container":"panoramaSlider_container__1_4Ir"};